import { render } from "./cwzbnewZui.vue?vue&type=template&id=aebb3004&scoped=true&ts=true"
import script from "./cwzbnewZui.vue?vue&type=script&lang=ts"
export * from "./cwzbnewZui.vue?vue&type=script&lang=ts"

import "./cwzbnewZui.vue?vue&type=style&index=0&id=aebb3004&lang=less&scoped=true"

import exportComponent from "E:\\operationmanualNew\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aebb3004"]])

export default __exports__